import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import { publishChecklist } from '../../utility/certificationBuilder'

import classes from './PublishChecklist.module.scss'

const labelKey = (item) => item.key === 'curriculum' && !item.done ? 'curriculumMissing' : item.key

const PublishChecklist = ({ certification }) => {
  const { t } = useTranslation()
  const items = publishChecklist(certification)

  return (
    <div className={classes.card}>
      <div className={classes.eyebrow}>{t('certificationBuilder.checklist.title')}</div>
      <ul className={classNames('list-unstyled mb-0 d-flex flex-column', classes.list)}>
        {items.map(item => (
          <li key={item.key} className='d-flex'>
            <i
              className={classNames(item.done ? 'fa fa-check-circle' : 'fa fa-exclamation-circle', item.done ? classes.done : classes.todo)}
              aria-hidden='true'
            />
            {t(`certificationBuilder.checklist.${labelKey(item)}`, item)}
          </li>
        ))}
      </ul>
    </div>
  )
}

PublishChecklist.propTypes = {
  certification: PropTypes.shape({
    sections: PropTypes.array.isRequired,
    finalQuiz: PropTypes.object.isRequired,
    prices: PropTypes.array.isRequired,
    accolade: PropTypes.object,
  }).isRequired,
}

export default PublishChecklist
